import { Popover as MantinePopover } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./popover.module.scss";
import type { CustomPopoverFactory, IProps } from "./popover.types";

const Popover = componentWrapper<CustomPopoverFactory, IProps>("Popover", (props, _ref) => {
    return <MantinePopover classNames={{ dropdown: styles["container"] }} {...props}></MantinePopover>;
});

Popover.Target = MantinePopover.Target;
Popover.Dropdown = MantinePopover.Dropdown;

export { Popover };
